import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { motion } from "framer-motion";

// Landing Page Sections
import Hero from "./sections/Hero";
import About from "./sections/About";
import Services from "./sections/Services";
import HowItWorks from "./sections/HowItWorks";
import Implementation from "./sections/Implementation";
import SuperchargedSuccess from "./sections/SuperchargedSuccess";
import MoreServices from "./sections/MoreServices";
import CTA from "./sections/CTA";
import Footer from "./sections/Footer";

const LandingPage = () => {
  useEffect(() => {
    // Initialize scroll reveal effect
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    revealElements.forEach(element => {
      observer.observe(element);
    });
    
    return () => {
      revealElements.forEach(element => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Hero />
      <About />
      <Services />
      <HowItWorks />
      <Implementation />
      <SuperchargedSuccess />
      <MoreServices />
      <CTA />
      <Footer />
    </motion.div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
